import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import { AppState } from 'helpers/store/models/AppState';
import { GetKahlPayload } from 'models/KahlMessage';
import { selectIsUserInternal } from 'saga/auth/ducks';
import { getKahlActions } from 'saga/kahl/ducks';
import { selectProperties } from 'saga/property/ducks';
import { selectLastActivityTime } from 'saga/userActivity/ducks';

const UserActivity = ({ properties, showKahl, userActivityTime, isInternal }: StateToProps & DispatchToProps) => {
  const [userWasRedirected, setUserWasRedirected] = useState(false);
  const logoutTimer = useRef(setTimeout(() => '', 0));
  const upcomingLogoutTimer = useRef(setTimeout(() => '', 0));
  const loginType = isInternal ? '&internalLogin=true' : '&externalLogin=true';

  useEffect(() => {
    if (properties['gui.timer.upcomingLogout'] && properties['gui.timer.logout']) {
      clearTimeout(logoutTimer.current);
      clearTimeout(upcomingLogoutTimer.current);

      if (!userWasRedirected) {
        upcomingLogoutTimer.current = setTimeout(() => {
          showKahl({ infoMessageIds: 'ID1571' });
        }, properties['gui.timer.upcomingLogout'] * 60000);
        logoutTimer.current = setTimeout(() => {
          setUserWasRedirected(true);
          window.location.href = `${properties['gui.loginPage.url']}?reason=timeout${loginType}`;
        }, properties['gui.timer.logout'] * 60000);
      }
    }
  }, [userActivityTime, userWasRedirected]);

  return null;
};

interface StateToProps {
  properties: Record<string, any>;
  userActivityTime: Date | null;
  isInternal?: boolean;
}

interface DispatchToProps {
  showKahl: (payload?: GetKahlPayload) => void;
}

const mapStateToProps = (state: AppState): StateToProps => ({
  properties: selectProperties(['gui.timer.upcomingLogout', 'gui.timer.logout', 'gui.loginPage.url']),
  userActivityTime: selectLastActivityTime(state),
  isInternal: selectIsUserInternal(state),
});

const mapDispatchToProps: DispatchToProps = {
  showKahl: getKahlActions.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserActivity);
